/* RENIVORA ™ — comportements de la page produit */
(function () {
  if (window.__rnvLoaded) return;
  window.__rnvLoaded = true;

  var MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- Swiper (chargé une seule fois) ---------- */
  var swiperQueue = [];
  var swiperLoading = false;
  function withSwiper(cb) {
    if (window.Swiper) return cb();
    swiperQueue.push(cb);
    if (swiperLoading) return;
    swiperLoading = true;
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    s.onload = function () { swiperQueue.splice(0).forEach(function (f) { f(); }); };
    document.head.appendChild(s);
  }

  function repeatSlides(slider, minimum) {
    var wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    wrapper.querySelectorAll('[data-rnv-clone]').forEach(function (c) { c.remove(); });
    var originals = Array.prototype.slice.call(wrapper.querySelectorAll('.swiper-slide'));
    if (!originals.length) return;
    var repeat = Math.max(3, Math.ceil(minimum / originals.length));
    for (var i = 1; i < repeat; i++) {
      originals.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-rnv-clone', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        wrapper.appendChild(clone);
      });
    }
  }

  var SWIPER_CONFIGS = {
    benefits: function (el) {
      repeatSlides(el, 12);
      return {
        slidesPerView: 1.08, slidesPerGroup: 1, spaceBetween: 20, loop: true, speed: 550,
        observer: true, observeParents: true, resizeObserver: true,
        navigation: { nextEl: el.querySelector('.block__pso-benefits-arrow--next'), prevEl: el.querySelector('.block__pso-benefits-arrow--prev') },
        breakpoints: { 0: { slidesPerView: 1.3, spaceBetween: 20 }, 750: { slidesPerView: 2, spaceBetween: 20 }, 990: { slidesPerView: 3, spaceBetween: 24 }, 1180: { slidesPerView: 4, spaceBetween: 24 } }
      };
    },
    reviews: function (el) {
      return {
        slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 16, loop: false, rewind: true, watchOverflow: true, speed: 550,
        observer: true, observeParents: true, resizeObserver: true,
        navigation: { nextEl: el.querySelector('.block__pso-review-arrow--next'), prevEl: el.querySelector('.block__pso-review-arrow--prev') },
        pagination: { el: el.querySelector('.block__pso-review-pagination'), clickable: true },
        breakpoints: { 0: { slidesPerView: 1, spaceBetween: 18 }, 749: { slidesPerView: 2, spaceBetween: 14 }, 1090: { slidesPerView: 3, spaceBetween: 14 } }
      };
    },
    articles: function (el) {
      return {
        slidesPerView: 1.04, slidesPerGroup: 1, spaceBetween: 10, loop: false, rewind: false, watchOverflow: true, speed: 550,
        observer: true, observeParents: true, resizeObserver: true,
        navigation: { nextEl: el.querySelector('.block__pso-articles-arrow--next'), prevEl: el.querySelector('.block__pso-articles-arrow--prev') },
        pagination: { el: el.querySelector('.block__pso-articles-pagination'), clickable: true },
        breakpoints: { 0: { slidesPerView: 1, spaceBetween: 14 }, 750: { slidesPerView: 2, spaceBetween: 10 }, 990: { slidesPerView: 2.2, spaceBetween: 14 }, 1190: { slidesPerView: 3, spaceBetween: 14 } }
      };
    }
  };

  function initSwipers(root) {
    var sliders = (root || document).querySelectorAll('[data-rnv-swiper]');
    if (!sliders.length) return;
    withSwiper(function () {
      sliders.forEach(function (el) {
        if (el.swiper) el.swiper.destroy(true, true);
        var cfg = SWIPER_CONFIGS[el.getAttribute('data-rnv-swiper')];
        if (cfg) new window.Swiper(el, cfg(el));
      });
    });
  }

  /* ---------- Date de livraison ---------- */
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-rnv-delivery]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-rnv-delivery'), 10) || 3;
      var d = new Date();
      d.setDate(d.getDate() + days);
      el.textContent = d.getDate() + ' ' + MONTHS[d.getMonth()];
    });
  }

  /* ---------- Défilement vers le sélecteur de quantité ---------- */
  function headerOffset() {
    var h = document.querySelector('.section-header, sticky-header, header');
    if (!h) return 16;
    var r = h.getBoundingClientRect();
    var pos = window.getComputedStyle(h).position;
    if ((pos === 'sticky' || pos === 'fixed' || r.top >= -1) && r.bottom > 0) return Math.min(r.bottom, 150) + 16;
    return 16;
  }

  function packsRoot() { return document.querySelector('[data-rnv-packs]'); }

  function goToPacks(packIndex) {
    var p = packsRoot();
    if (!p) return;
    if (packIndex) {
      var input = p.querySelector('.mpv3-switcher__radio[value="' + packIndex + '"]');
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var y = p.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    setTimeout(function () { var y2 = p.getBoundingClientRect().top + window.pageYOffset - headerOffset(); if (Math.abs(y2 - window.pageYOffset) > 40) window.scrollTo({ top: Math.max(0, y2), behavior: 'smooth' }); }, 700);
  }
  window.rnvGoToPacks = goToPacks;

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-rnv-cta]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href && href !== '#' && href.indexOf('#rnv-packs') !== 0) return; /* lien personnalisé */
    e.preventDefault();
    goToPacks(a.getAttribute('data-rnv-pack'));
  });

  /* ---------- Sélecteur de packs (fiche produit) ---------- */
  function parseEuro(s) {
    if (!s) return NaN;
    var t = String(s).replace(/[^\d,.\-]/g, '');
    if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.');
    return parseFloat(t);
  }
  function formatEuro(n) {
    var s = n.toFixed(2).replace('.', ',');
    if (/,00$/.test(s)) s = s.slice(0, -3);
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function initPacks() {
    var root = packsRoot();
    if (!root || root.__rnv) return;
    root.__rnv = true;
    var formId = root.getAttribute('data-form-id');
    var cta = root.querySelector('[data-rnv-atc]');
    var errorEl = root.querySelector('.mpv3-pack__error');

    function form() { return document.getElementById(formId) || document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]'); }
    function selected() { return root.querySelector('.mpv3-switcher__radio:checked') || root.querySelector('.mpv3-switcher__radio'); }

    function apply() {
      var input = selected();
      if (!input) return;
      var f = form();
      if (f) {
        var idInput = f.querySelector('[name="id"]');
        if (idInput && input.getAttribute('data-variant-id')) idInput.value = input.getAttribute('data-variant-id');
        var q = f.querySelector('input[name="quantity"]');
        if (!q) { q = document.createElement('input'); q.type = 'hidden'; q.name = 'quantity'; f.appendChild(q); }
        q.value = input.getAttribute('data-qty') || '1';
      }
      var price = input.getAttribute('data-price') || '';
      var compare = input.getAttribute('data-compare') || '';
      if (cta) {
        var label = cta.getAttribute('data-label') || '';
        var txt = cta.querySelector('.mpv3-switchers__cta-text');
        if (txt) txt.textContent = label + (price ? ' - ' + price : '');
      }
      document.querySelectorAll('[data-rnv-price-row]').forEach(function (row) {
        var cur = row.querySelector('.js-rnv-price-current');
        var old = row.querySelector('.js-rnv-price-old');
        var sale = row.querySelector('.js-rnv-price-sale');
        if (cur) cur.textContent = price;
        if (old) { old.textContent = compare; old.style.display = compare ? 'inline' : 'none'; }
        if (sale) {
          var tpl = row.getAttribute('data-sale-template') || '';
          var diff = parseEuro(compare) - parseEuro(price);
          if (tpl && !isNaN(diff) && diff > 0) { sale.textContent = tpl.replace('[montant]', formatEuro(diff)); sale.style.display = 'inline-block'; }
          else if (tpl) { sale.style.display = 'none'; }
        }
      });
    }

    root.addEventListener('change', function (e) { if (e.target.classList.contains('mpv3-switcher__radio')) apply(); });

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        var f = form();
        if (!f) return;
        apply();
        var btn = f.querySelector('[type="submit"]');
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        cta.classList.add('is-loading');
        var done = function () { cta.classList.remove('is-loading'); };
        if (btn) {
          var mo = new MutationObserver(function () {
            if (btn.getAttribute('aria-disabled') !== 'true' && !btn.classList.contains('loading')) { done(); mo.disconnect(); }
          });
          mo.observe(btn, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
        }
        setTimeout(done, 5000);
        if (f.requestSubmit) f.requestSubmit(btn || undefined);
        else if (btn) btn.click();
        else f.submit();
      });
    }

    apply();
    setTimeout(apply, 600);
    setTimeout(apply, 1500);
  }

  /* ---------- Offres « stock » (section) ---------- */
  function initBundles() {
    document.querySelectorAll('[data-rnv-bundle]').forEach(function (wrap) {
      if (wrap.__rnv) return;
      wrap.__rnv = true;
      var cards = Array.prototype.slice.call(wrap.querySelectorAll('.pdp-bundle-picker__card-wrap'));
      var mobile = wrap.querySelector('.pdp-bundle-picker__mobile-cta');
      function select(card) {
        cards.forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
        card.classList.add('is-selected');
        card.setAttribute('aria-checked', 'true');
        if (mobile) {
          mobile.setAttribute('data-rnv-pack', card.getAttribute('data-pack') || '');
          var p = mobile.querySelector('.pdp-bundle-picker__mobile-cta-price');
          var c = mobile.querySelector('.pdp-bundle-picker__mobile-cta-compare s');
          if (p) p.textContent = card.getAttribute('data-sale-price') || '';
          if (c) { c.textContent = card.getAttribute('data-compare-price') || ''; c.parentNode.style.display = c.textContent ? '' : 'none'; }
        }
      }
      cards.forEach(function (card) {
        card.addEventListener('click', function (e) { if (!e.target.closest('[data-rnv-cta]')) select(card); });
        card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(card); } });
      });
    });
  }

  /* ---------- Bienfaits dépliables ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rnv-dropdown] .block__pso-benefi-drop-down-trigger');
    if (!btn) return;
    var item = btn.closest('.block__pso-benefi-drop-down-item');
    var open = !item.classList.contains('is-open');
    item.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
  });

  /* ---------- FAQ exclusive ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var list = d.closest('[data-rnv-faq]');
    if (!list) return;
    list.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
  }, true);

  /* ---------- Parcours (timeline) ---------- */
  if (!customElements.get('rnv-journey-timeline')) {
    customElements.define('rnv-journey-timeline', class extends HTMLElement {
      connectedCallback() {
        var ms = this.querySelectorAll('.pumpkin_pdp_journey_timeline__milestone');
        if (!ms.length || !('IntersectionObserver' in window)) { ms.forEach(function (m) { m.classList.add('is-active'); }); return; }
        this._obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.rootBounds) return;
            var cleared = entry.boundingClientRect.bottom <= entry.rootBounds.bottom;
            var past = entry.boundingClientRect.top <= entry.rootBounds.top;
            entry.target.classList.toggle('is-active', cleared || past);
          });
        }, { rootMargin: '0px 0px -200px 0px', threshold: [0, 0.25, 0.5, 0.75, 1] });
        var o = this._obs;
        ms.forEach(function (m) { o.observe(m); });
      }
      disconnectedCallback() { if (this._obs) this._obs.disconnect(); }
    });
  }

  /* ---------- Liste d'avis (lire plus) ---------- */
  if (!customElements.get('rnv-reviews-list')) {
    customElements.define('rnv-reviews-list', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var btn = this.querySelector('.pumpkin_pdp_reviews_list__toggle');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var ex = !self.classList.contains('is-expanded');
          self.classList.toggle('is-expanded', ex);
          btn.setAttribute('aria-expanded', ex ? 'true' : 'false');
          btn.textContent = ex ? btn.dataset.labelLess : btn.dataset.labelMore;
        });
      }
    });
  }

  /* ---------- Onglets dépliables (fiche produit) ---------- */
  if (!customElements.get('rnv-accordion')) {
    customElements.define('rnv-accordion', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var trigger = this.querySelector('.mpv1-accordion__trigger');
        var panel = this.querySelector('.mpv1-accordion__panel');
        var content = this.querySelector('.mpv1-accordion__content');
        function setH() { self.style.setProperty('--mpv1-accordion-height', content.scrollHeight + 'px'); }
        setH();
        window.addEventListener('resize', setH);
        trigger.addEventListener('click', function () {
          setH();
          var open = !self.classList.contains('is-open');
          self.classList.toggle('is-open', open);
          trigger.setAttribute('aria-expanded', String(open));
        });
        if (panel) panel.addEventListener('transitionend', setH);
      }
    });
  }

  /* ---------- Vidéos clients ---------- */
  function initUgc() {
    document.querySelectorAll('[data-rnv-ugc]').forEach(function (box) {
      if (box.__rnv) return;
      box.__rnv = true;
      var track = box.querySelector('.mpv1-ugc-videos__track');
      box.querySelectorAll('.mpv1-ugc-videos__video-wrapper').forEach(function (w) {
        var v = w.querySelector('video');
        var play = w.querySelector('.mpv1-ugc-videos__play-btn');
        var mute = w.querySelector('.mpv1-ugc-videos__mute-btn');
        function sync() {
          play.querySelector('.mpv1-ugc-videos__icon-play').hidden = !v.paused;
          play.querySelector('.mpv1-ugc-videos__icon-pause').hidden = v.paused;
          mute.querySelector('.mpv1-ugc-videos__icon-muted').hidden = !v.muted;
          mute.querySelector('.mpv1-ugc-videos__icon-unmuted').hidden = v.muted;
          play.setAttribute('aria-label', v.paused ? 'Lire la vidéo' : 'Mettre en pause');
          mute.setAttribute('aria-label', v.muted ? 'Activer le son' : 'Couper le son');
        }
        function toggle() {
          if (v.paused) {
            box.querySelectorAll('video').forEach(function (o) { if (o !== v) o.pause(); });
            v.play();
          } else v.pause();
        }
        play.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
        v.addEventListener('click', toggle);
        mute.addEventListener('click', function (e) { e.stopPropagation(); v.muted = !v.muted; sync(); });
        v.addEventListener('play', sync);
        v.addEventListener('pause', sync);
        sync();
      });
      var prev = box.querySelector('.mpv1-ugc-videos__arrow--prev');
      var next = box.querySelector('.mpv1-ugc-videos__arrow--next');
      function step() { var it = track.querySelector('.mpv1-ugc-videos__item'); return it ? it.getBoundingClientRect().width + 8 : 200; }
      function upd() {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* ---------- Sur ordinateur : onglets + vidéos sous la galerie ---------- */
  function placeGalleryExtras() {
    var items = document.querySelectorAll('[data-rnv-desktop-gallery]');
    if (!items.length) return;
    var media = document.querySelector('.product__media-wrapper');
    if (!media) return;
    /* Seulement si la galerie existe et s'affiche à côté des infos (sinon on laisse tout dans la colonne infos) */
    var product = media.closest('.product');
    var info = document.querySelector('.product__info-wrapper');
    var hasMedia = !!media.querySelector('.product__media-item, .product__media, img, video') && !(product && product.classList.contains('product--no-media'));
    var sideBySide = !!info && info.getBoundingClientRect().left >= media.getBoundingClientRect().right - 2;
    var desktop = window.matchMedia('(min-width: 750px)').matches && hasMedia && sideBySide;
    var holder = media.querySelector('.rnv-gallery-extras');
    if (desktop) {
      if (!holder) { holder = document.createElement('div'); holder.className = 'rnv-gallery-extras'; media.appendChild(holder); }
      items.forEach(function (el) {
        if (el.parentNode === holder) return;
        if (!el.__rnvHome) { el.__rnvHome = document.createComment('rnv'); el.parentNode.insertBefore(el.__rnvHome, el); }
        holder.appendChild(el);
      });
    } else {
      items.forEach(function (el) {
        if (el.__rnvHome && el.parentNode !== el.__rnvHome.parentNode) el.__rnvHome.parentNode.insertBefore(el, el.__rnvHome);
      });
    }
  }

  function initAll() {
    initSwipers();
    initDelivery();
    initPacks();
    initBundles();
    initUgc();
    placeGalleryExtras();
  }

  ready(initAll);
  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(placeGalleryExtras, 150);
  });
  document.addEventListener('shopify:section:load', function (e) {
    setTimeout(function () {
      initSwipers(e.target);
      initDelivery(e.target);
      var p = packsRoot(); if (p) p.__rnv = false;
      initPacks();
      initBundles();
      initUgc();
      placeGalleryExtras();
    }, 50);
  });
})();
